// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CreditCardTwoToneSvg from "@ant-design/icons-svg/es/asn/CreditCardTwoTone";
import AntdIcon from '../components/AntdIcon';

var CreditCardTwoTone = function CreditCardTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CreditCardTwoToneSvg
  }));
};

CreditCardTwoTone.displayName = 'CreditCardTwoTone';
export default React.forwardRef(CreditCardTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CreditCardTwoTone.js
// module id = 889
// module chunks = 0